import { padStart } from 'lodash';

export function getDateString(date: Date) {
    const fullYear = padZeros(date.getFullYear(), 4);
    const normalizedMonth = padZeros(date.getMonth() + 1);
    const normalizedDate = padZeros(date.getDate());

    return `${fullYear}-${normalizedMonth}-${normalizedDate}`;
}

export function getDateTimeString(date: Date) {
    return (
        getDateString(date) +
        'T' +
        padZeros(date.getHours()) +
        ':' +
        padZeros(date.getMinutes()) +
        ':' +
        padZeros(date.getSeconds()) +
        '.' +
        padZeros(date.getMilliseconds(), 3)
    );
}

function padZeros(value: string | number, zeros = 2) {
    return padStart(value.toString(), zeros, '0');
}
